module.exports = __webpack_public_path__ + "img/ecp-dagger.5e2650bf.svg";